import { Reducer } from 'redux';
import { produce } from 'immer';

import { STORE_TYPES, StoreContextState } from './types';

export const INITIAL_STATE: StoreContextState = {
  stores: [],
  cpId: 0,
};

const reducer: Reducer<StoreContextState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case STORE_TYPES.GET_STORE_DATA:
        draft.stores = action.payload.stores;
        draft.cpId = action.payload.cp;
        break;
      default:
    }
  });
};

export default reducer;
